export const ADD_COMPANY = "ADD_COMPANY";
export const GET_COMPANIES = "GET_COMPANIES";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
